import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";

import translationEn from "./locales/en/translation.json";
import translationId from "./locales/id/translation.json";

i18n
  // .use(XHR)
  .use(LanguageDetector)
  .init({
    debug: false,
    fallbackLng: "id",

    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },

    resources: {
      en: {
        translations: translationEn,
      },
      id: {
        translations: translationId,
      },
    },
    ns: ["translations"],
    defaultNS: "translations",
    detection: {
      order: ['path', 'querystring'],
      lookupFromPathIndex: 1,
    }
  });

export default i18n;
